import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import spartaUILayersUtility from "global/sparta-ui-layers-utility";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import urlCampaignCodeUtility from "community/url-campaign-code-utility";
import pictureHelper from "helpers/helpers-picture";
import spartaTemplates from "modules/home-loans/general-engagement-module/1.0.0/js/templates";
import "css!modules/home-loans/general-engagement-module/1.0.0/css/general-engagement-module.scss.css";










export default class generalEngagementModuleJS extends Module {
    constructor(options) {
        super(options);
        console.log("generalEngagementModuleJS Instantiated with options:", options);
    }

    init(args = {}) {
        console.log("generalEngagementModuleJS Called with arguments===>", args);
        console.log('===Trying to sub to an event===');
    }

}
